let objects3DList = {
    "doubleChairWithPillow": { 
        "itemName": "DoubleChairWithPillow",
        "itemType": 1,
        "position": [
            209.43984621295914,
            49.05,
            270.9912269855666
        ],
        "rotation": [
            0,
            0,
            0
        ],
        "scale": [
            1,
            1,
            1
        ],
        "size": [
            108.85,
            72.7337,
            69.2864
        ],
        "fixed": false,
        "resizable": false,
        "modelURL": "models/DoubleChairWithPillow.glb",
        "isParametric": false
    },
    "Ping Pong Table":{
        "itemName": "Tennis Table",
            "itemType": 1,
            "position": [
                280,
                50,
                350
            ],
            "rotation": [
                0,
                0,
                0
            ],
            "scale": [
                1,
                1,
                1
            ],
            "size": [
                281.598,
                98.1,
                172.4
            ],
            "fixed": false,
            "resizable": false,
            "modelURL": "models/TableTennisTable.glb",
            "isParametric": false

    },
    "table":{
        "itemName": "Andrea Wox Table",
            "itemType": 1,
            "position": [
                280,
                25,
                130
            ],
            "rotation": [
                0,
                0,
                0
            ],
            "scale": [
                1,
                1,
                1
            ],
            "size": [
                161.0,
                51.8,
                161.0
            ],
            "fixed": false,
            "resizable": false,
            "modelURL": "models/AndreaWox_Table_Resized.glb",
            "isParametric": false

    }
}

export {objects3DList};